import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from 'ui';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import LessonTemplateImageUpload from 'components/content/TemplateImageUpload';
import * as actions from '../../actions/editor/template';
import { useClearNotificationEffect } from '../settings/shared/hooks';
import StatusLabel from '../settings/shared/StatusLabel';

const LessonTemplateImagesModal = ({
  contentId,
  closeModal,
  canManageContentLibrary,
  allowImageLibrary,
  onToggleTemplateImageSuccess,
  templateImageSuccess,
}) => {
  const clearSuccess = () => {
    onToggleTemplateImageSuccess(false);
  };

  useClearNotificationEffect(templateImageSuccess, null, clearSuccess, 3000);

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container TemplateImagesModal">
          <div className="TemplateImagesModal-body">
            <div className="TemplateImagesModal-title">
              {t('templates.images_modal.title')}
            </div>
            <div className="TemplateImagesModal-subtitle mt-16">
              {t('templates.images_modal.cover_image_subtitle')}
            </div>
            <p className="mt-2 mb-16">
              {t('templates.images_modal.cover_image_text')}
            </p>
            <button
              type="button"
              className="u-resetBtn ModalTakeover-closeButton"
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
            <LessonTemplateImageUpload
              contentId={contentId}
              contentType="Drafts::Lesson"
              imageType="cover"
              allowImageLibrary={allowImageLibrary}
              canManageContentLibrary={canManageContentLibrary}
            />
            <div className="TemplateImagesModal-subtitle mt-24">
              {t('templates.images_modal.background_image_subtitle')}
            </div>
            <p className="mt-2 mb-16">
              {t('templates.images_modal.background_image_text')}
            </p>
            <LessonTemplateImageUpload
              contentId={contentId}
              contentType="Drafts::Lesson"
              imageType="background"
              allowImageLibrary={allowImageLibrary}
              canManageContentLibrary={canManageContentLibrary}
            />
            <div className="TemplateImagesModal-actions">
              <StatusLabel className="mr-16" success={templateImageSuccess} />
              <Button onClick={closeModal}>Close</Button>
            </div>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

const mapStateToProps = ({ editor, meta }) => ({
  canManageContentLibrary: meta.currentUser.canManageContentLibrary,
  allowImageLibrary: meta.currentUser.allowImageLibrary,
  templateImageSuccess: editor.templateImageSuccess,
});

const mapDispatchToProps = dispatch => ({
  onToggleTemplateImageSuccess: success =>
    dispatch(actions.templateToggleImageSuccess(success)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LessonTemplateImagesModal);
